import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import ReadOnlyField from 'Components/UI/Overrides/ReadOnlyField';
import Button from 'Components/UI/Button';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const styles = (theme) => ({
  root: {
    paddingBottom: 0,
  },
  button: {
    borderRadius: theme.radius.md,
  },
});

// this component only works in managed account allocation clean up page
const AssignToMeButton = ({
  className,
  classes,
  resource,
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const canBeAssigned = resource && resource.relationship(fr.relationships.assignInOpsAgent.name);

  const onClick = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      await resource.relationship(fr.relationships.assignInOpsAgent.name).link('related').put({}, { deprecatedAllowAlterOfRelation: true });
      await refreshPageContentCollection();
    } catch (err) {
      displayErrorMessage('failed to assign to managed account allocation');
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {resource.attr('assignedInOpsAgentId') && (
        <ReadOnlyField classes={classes} value={resource.selectedOptionPrompt('assignedInOpsAgentId')} />
      )}
      {canBeAssigned && !resource.attr('assignedInOpsAgentId') && (
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => onClick(e)}
        >
          {'Assign To Me'}
        </Button>
      )}
    </Box>
  );
};

AssignToMeButton.defaultProps = {
  className: '',
};

AssignToMeButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AssignToMeButton);
